<template lang="jade">
  ul.list-unstyled(style="margin: 0 1em")
    li(v-for="item in fdata.content | blanks")
      a.link(":href"="item | link" target="_blank" download)
        span.link__icon
          i.fa.fa-file-text-o 
        span.link__text {{ item.title }}
</template>
<script>
import _ from 'lodash'
import api from 'src/config/api'

export default {
  data () {
    return {}
  },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  },
  filters: {
    link (x) {
      return api.http.root + '/data/asset/download?siteId=Member&assetId=' + x.assetId
    },
    stripBlanks (coll) {
      return _.filter(coll, xs => !_.isEmpty(xs.title))
    }
  }
}
</script>




// WEBPACK FOOTER //
// assets.vue?1d84c7cd